import { Button, Card, Col, Input, Row } from "antd";
import React, { useState } from "react";
import { RiAddCircleFill } from "react-icons/ri";
import { CgCloseO } from "react-icons/cg";

import "./Dependents.css";

function Dependents({ data }) {
  const [checked, setChecked] = useState(false);

  const [dependents, setDependents] = useState([
    {
      name: "",
      address: "",
      phoneNumber: "",
      relationship: "",
    },
  ]);

  const addAnotherDependent = () => {
    setDependents([
      ...dependents,

        {
            name: "",
            address: "",
            phoneNumber: "",
            relationship: "",
          },
    
    ]);
  };

  const onRemoveDependent = (index) => {
    const newDependents = [...dependents];
    newDependents.splice(index, 1);
    setDependents(newDependents);
  };
  return (
    <Row className="dependents">
      <Col span={24}>
        <Card
          title="Dependents"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <Row justify="start" gutter={[8, 0]}>
                  <Col className="header-row" span={6}>
                    <span>First Name</span>
                  </Col>
                  <Col className="header-row" span={6}>
                    <span>Last name</span>
                  </Col>
                  <Col className="header-row" span={6}>
                    <span>Relationship</span>
                  </Col>
                  <Col className="header-row" span={5}>
                    <span>Date of Birth</span>
                  </Col>
                </Row>
              </Col>
              {dependents.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={6}>
                        <Input placeholder="First Name" />
                      </Col>
                      <Col span={6}>
                        <Input placeholder="Last Name" />
                      </Col>
                      <Col span={6}>
                        <Input placeholder="Relationship" />
                      </Col>
                      <Col span={5}>
                        <Input placeholder="Date of birth" />
                      </Col>
                      {dependents.length > 1 ? (
                        <Col span={1}>
                          <CgCloseO
                            className="delete-btn"
                            size={20}
                            onClick={() => onRemoveDependent(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  onClick={() => addAnotherDependent()}
                  className="add-icon-btn"
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Dependent</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={6}>
                          <span>First Name</span>
                        </Col>
                        <Col span={6}>
                          <span>Last Name</span>
                        </Col>
                        <Col span={6}>
                          <span>Relationship</span>
                        </Col>
                        <Col span={6}>
                          <span>Date of Birth</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.make}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.model}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.color}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.licenseNo}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>Click edit to add dependent.</p>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default Dependents;
